import "./utilities/jqueryLoad.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'slick-carousel';
import {runApp} from "./run-app";

$(window).on("load", function () {
    document.body.className = document.body.className.replace("no-js", "js");
    $('#preloader').addClass('d-none')
    $('body').removeClass('overflow-hidden');
    runApp();


});

document.addEventListener('DOMContentLoaded', function () {
    const unMuteIcon = document.getElementById('homeUnMuteSound');
    const muteIcon = document.getElementById('homeMuteSound');
    const video = document.getElementById('homeMainVideo');

    unMuteIcon.addEventListener('click', function () {
        console.log('click unmute');
        video.muted = false;
        unMuteIcon.style.display = 'none';
        muteIcon.style.display = 'block';
    });

    muteIcon.addEventListener('click', function () {
        console.log('click mute');
        video.muted = true;
        muteIcon.style.display = 'none';
        unMuteIcon.style.display = 'block';
    });
})
